import {
  makeStyles,
  MessageBar,
  MessageBarBody,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { Activity } from "../../models/Activity";
import { InfoFilled } from "@fluentui/react-icons";

const useClasses = makeStyles({
  root: {
    marginTop: "10px",
  },
});

interface ComplianceWarningMessageBarProps {
  activity: Activity;
}

export const ComplianceWarningMessageBar = (
  props: ComplianceWarningMessageBarProps
) => {
  const { activity } = props;
  const { t } = useTranslation();
  const classes = useClasses();

  if (
    !activity.fieldValues ||
    !activity.fieldValues.tags["compliance"] ||
    activity.fieldValues.tags["compliance"].length === 0
  ) {
    return null;
  }

  return (
    <MessageBar
      className={classes.root}
      intent="warning"
      shape="square"
      icon={<InfoFilled />}
    >
      <MessageBarBody>{t("complianceBannerText")}</MessageBarBody>
    </MessageBar>
  );
};
